import styled from "styled-components";

export const BodyWrapper = styled.div`
  background: #030303;
`;
